// Aquí está el slice de usuario
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  infoCrearEmpresa: null,
  failureCrearEmpresa: false,
  isLoadingCrearEmpresa: false,
  errorCrearEmpresa: null,
};

const crearEmpresaSlice = createSlice({
  name: "crearEmpresa",
  initialState,
  reducers: {
    crearEmpresaSuccess: (state, action) => {
      state.infoCrearEmpresa = action.payload.info;
      state.failureCrearEmpresa = false;
      state.isLoadingCrearEmpresa = false;
    },
    crearEmpresaFailure: (state, action) => {
      state.failureCrearEmpresa = true;
      state.isLoadingCrearEmpresa = false;
      state.errorCrearEmpresa = action.payload; // mensaje de errorCrearEmpresa
    },
    crearEmpresaReset: (state) => {
      state.infoCrearEmpresa = null;
      state.failureCrearEmpresa = false;
      state.errorCrearEmpresa = null;
      state.isLoadingCrearEmpresa = false;
    },
    setInfoEmpresa: (state, action) => {
      state.infoCrearEmpresa = action.payload;
    }
  },
});


export const {
  crearEmpresaSuccess,
  crearEmpresaFailure,
  crearEmpresaReset,
  setInfoEmpresa,
} = crearEmpresaSlice.actions;
export default crearEmpresaSlice.reducer;
